// in ./ResetViewsButton.js
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, crudUpdateMany, startUndoable, crudUpdate } from 'react-admin';

class MovetoHandlingButton extends Component {
    handleClick = () => {
        const {  basePath, resource, selectedIds, startUndoable } = this.props;
        startUndoable(
            crudUpdateMany(resource, selectedIds, { status: "handling" }, basePath)
        );
    };

    render() {
        return (
            <Button label="Move to Handling" onClick={this.handleClick} />
        );
    }
}

export default connect(undefined, { startUndoable })(MovetoHandlingButton);